import { FreemiumRewardFeature } from "@seneca/xp-service-consts";

export const FreemiumRewardFeatures = Object.values(FreemiumRewardFeature);
